export const INVALID_PATTERN_CHARS = /[^\d\p{Letter}\-/_]/gu
